import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, State } from './general.reducer';

export const selectProjectState = createFeatureSelector<State>(featureKey);

export const getPolicyHolderAddressCheckbox = createSelector(
  selectProjectState,
  (state: State) => state.policyHolderAddressCheckbox
);

export const getPartnershipId = createSelector(selectProjectState, (state: State) => state.partnershipId);

export const getUserId = createSelector(selectProjectState, (state: State) => state.userId);

/**
 * @deprecated
 * (Not being used)
 */
export const getProjectId = createSelector(selectProjectState, (state: State) => state.projectId);

export const getPolicyId = createSelector(selectProjectState, (state: State) => state.policyId);

export const getPolicyVersion = createSelector(selectProjectState, (state: State) => state.policyVersion);

export const getSessionId = createSelector(selectProjectState, (state: State) => state.sessionId);

export const getTkJwt = createSelector(selectProjectState, (state: State) => state.tkJwt);

export const getRtkJwt = createSelector(selectProjectState, (state: State) => state.rtkJwt);

export const getGwCookie = createSelector(selectProjectState, (state: State) => state.gwCookie);

export const getNoneUserParticipants = createSelector(selectProjectState, (state: State) => state.noneUserParticipant);

export const getIsPolicyFormPolicyNumber = createSelector(
  selectProjectState,
  (state: State) => state.isPolicyFormPolicyNumber
);

export const getIsMortgageBankData = createSelector(selectProjectState, (state: State) => state.isMortgageBankData);

export const getPrivacyPolicyInd = createSelector(selectProjectState, (state: State) => state.privacyPolicyInd);

export const getMarketingResearchInd = createSelector(selectProjectState, (state: State) => state.marketingResearchInd);

export const getCommercialCommInd = createSelector(selectProjectState, (state: State) => state.commercialCommInd);

export const getBusinessResearchInd = createSelector(selectProjectState, (state: State) => state.businessResearchInd);

export const getProfilingInd = createSelector(selectProjectState, (state: State) => state.profilingInd);

export const getPartnershipIntegrationInd = createSelector(
  selectProjectState,
  (state: State) => state.partnershipIntegrationInd
);

export const getUserFLow = createSelector(selectProjectState, (state: State) => state.userFlow);

export const getBackOfficeUser = createSelector(selectProjectState, (state: State) => state.isBackOfficeUser);

export const getGenesysChatInfo = createSelector(selectProjectState, (state: State) => state.genesysChatInfo);

export const getGenesysChatVisibilityInd = createSelector(selectProjectState, (state: State) => state.genesysChatVisibilityInd);